import requestManager from '@comp/platformApi/requestManager'
import appHelper from "@util/appHelper";

export default {

    getItem(id, callback) {
        requestManager.request({
            url: 'portal/vod/v2/',
            data: { id : id }
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result.data);
        });
    }
};
